export default "__VITE_ASSET__DzSzJm2h__"